module.exports = __webpack_public_path__ + "img/google-icon.7b4087fd.svg";